// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved
/* eslint-disable max-len */

import React from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';

import PropTypes from 'prop-types';

// eslint-disable-next-line node/no-missing-import
import TokenValidation from '../components/token-validation';
// eslint-disable-next-line node/no-missing-import
import RestoreResponse from '../components/restore-response';
// eslint-disable-next-line node/no-missing-import
import RestoreRequest from '../components/restore-request';
// eslint-disable-next-line node/no-missing-import
import MarketingCloudLogo from '../components/marketingCloudLogo';
// eslint-disable-next-line node/no-missing-import
import PageFooter from '../components/PageFooter';
// eslint-disable-next-line node/no-missing-import
import LanguageDropdown from '../components/languageDropdown';

import * as currentPageActions from '../actions/current-page-actions';
import * as apiActions from '../actions/apiActions';
import * as accessTokenActions from '../actions/access-token-actions';
import * as tokenValidationErrorActions from '../actions/token-validation-error-actions';
import * as languageActions from '../actions/language-actions';

// eslint-disable-next-line react/prefer-stateless-function
export class AppBare extends React.Component {
	render () {
		const { currentPage, restoreStatus, accessToken, userInfo, tokenValidationError } = this.props;
		// eslint-disable-next-line react/destructuring-assignment
		const { changeToRestoreRequestPage, changeToRestoreTokenValidationPage, changeToRestoreResponsePage } = this.props.currentPageActions;
		// eslint-disable-next-line react/destructuring-assignment
		const { validateAccessToken, processRestoreRequest } = this.props.apiActions;
		// eslint-disable-next-line react/destructuring-assignment
		const { setTokenValidationError } = this.props.tokenValidationErrorActions;
		// eslint-disable-next-line react/destructuring-assignment
		const { setLanguageInStore, markLangChanged } = this.props.languageActions;

		return (
			<div>
				<div className="slds-grid slds-grid_align-end">
					<div className="slds-col slds-align">
						<LanguageDropdown
							setLanguageInStore={setLanguageInStore}
							markLangChanged={markLangChanged}
						/>
					</div>
				</div>
				<MarketingCloudLogo />
				{ currentPage.tokenValidation ? (
					<TokenValidation
						changeToRestoreRequestPage={changeToRestoreRequestPage}
						validateAccessToken={validateAccessToken}
						setTokenValidationError={setTokenValidationError}
						tokenValidationError={tokenValidationError}
					/>
				) : null}
					
				{ currentPage.restoreRequest ? (
					<RestoreRequest
						changeToRestoreTokenValidationPage={changeToRestoreTokenValidationPage}
						changeToRestoreResponsePage={changeToRestoreResponsePage}
						processRestoreRequest={processRestoreRequest}
						accessToken={accessToken}
						userInfo={userInfo}
					/>
				) : null}

				{ currentPage.restoreResponse ? (
					<RestoreResponse
						restoreStatus={restoreStatus}
					/>
				) : null}
				<PageFooter />
			</div>
		);
	}
}

AppBare.propTypes = {
	currentPage: PropTypes.object.isRequired,
	currentPageActions: PropTypes.object.isRequired,
	restoreStatus: PropTypes.object.isRequired,
	apiActions: PropTypes.object.isRequired,
	accessToken: PropTypes.string.isRequired,
	accessTokenActions: PropTypes.object.isRequired,
	userInfo: PropTypes.object.isRequired,
	tokenValidationError: PropTypes.string.isRequired,
	tokenValidationErrorActions: PropTypes.object.isRequired,
	languageActions: PropTypes.object.isRequired
};

// eslint-disable-next-line no-unused-vars
function mapStateToProps (state, ownProps) {
	return {
		currentPage: state.currentPage,
		restoreStatus: state.restoreStatus,
		accessToken: state.accessToken,
		userInfo: state.userInfo,
		tokenValidationError: state.tokenValidationError
	};
}

function mapDispatchToProps (dispatch) {
	return {
		currentPageActions: bindActionCreators(currentPageActions, dispatch),
		apiActions: bindActionCreators(apiActions, dispatch),
		accessTokenActions: bindActionCreators(accessTokenActions, dispatch),
		tokenValidationErrorActions: bindActionCreators(tokenValidationErrorActions, dispatch),
		languageActions: bindActionCreators(languageActions, dispatch)
	};
}

export default compose(
	hot(module),
	connect(mapStateToProps, mapDispatchToProps)
)(AppBare);
